import {
    convertPersianDateToUniversalDate, convertUniversalDateToPersianDate,
    RaikoButtonPrimary,
    RaikoDatePicker,
    RaikoGridOneColumn,
    RaikoMoneyInputOutlined, showErrorMessage, showSuccessMessage, showWarningMessage,RaikoFlexAlignEnd
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {useEffect, useState} from "react";
import {AccountTransactionsService} from "../../../serverService/accountTransactions/AccountTransactionsService";
import {useAuthState} from "../../../context/AuthContext";
import {useParams} from "react-router-dom";
import {dateIsNotValid, numberIsEmpty} from "../../../util/VariableChecker";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";


export default function AccountMonthlyDepositNewTransaction(
    {
        transactionId = -1,
        handleAddNewTransactionToTable,
        handleUpdateTransactionInTable
    }
) {

    const {fundID} = useAuthState()
    const {id: accountId} = useParams()


    const service = new AccountTransactionsService()

    const [amount, setAmount] = useState("")
    const [date, setDate] = useState("");

    const loading = new LoadingHelper(useLoadingDispatcher())


    useEffect(() => {
        if (transactionId && transactionId >= 0) {
            getTransactionData()
        }
    }, [transactionId]);

    function getTransactionData() {
        loading.show()
        service.getAccountTransactionInfo(
            fundID,
            transactionId
        ).then(response => {
            setAmount(response.amount)
            setDate(convertUniversalDateToPersianDate(response.depositedAt))
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleChangeTransactionInfo() {
        if (checkFields()) {
            if (transactionId && transactionId >= 0) {
                handleUpdateTransaction()
            } else {
                handleAddNewTransaction()
            }
        }
    }

    function checkFields() {
        let state = false
        let message

        if (numberIsEmpty(amount))
            message = "لطفا مبلغ تراکنش را وارد نمایید."
        else if (dateIsNotValid(date))
            message = "لطفا تاریخ تراکنش را مشخص نمایید."
        else
            state = true

        if (message)
            showWarningMessage(message)

        return state
    }

    function handleAddNewTransaction() {
        loading.show()
        service.addNewTransaction(
            fundID,
            accountId,
            amount,
            convertPersianDateToUniversalDate(date)
        ).then(response => {
            showSuccessMessage("تراکنش جدید با موفقیت ثبت شد.")
            handleAddNewTransactionToTable(response)
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }


    function handleUpdateTransaction() {
        loading.show()
        service.handleUpdateTransaction(
            fundID,
            transactionId,
            amount,
            convertPersianDateToUniversalDate(date)
        ).then(response => {
            showSuccessMessage("تراکنش با موفقیت بروزرسانی شد.")
            handleUpdateTransactionInTable(response)
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem`}>
            <RaikoMoneyInputOutlined
                labelText={"مبلغ (ریال)"}
                value={amount}
                setValue={setAmount}
            />
            <RaikoDatePicker
                label={"تاریخ پرداخت"}
                date={date}
                setDate={setDate}
            />
            <RaikoFlexAlignEnd>
                <RaikoButtonPrimary
                    label={"ثبت و بروزرسانی"}
                    onClick={handleChangeTransactionInfo}
                />
            </RaikoFlexAlignEnd>
        </RaikoGridOneColumn>
    )
}
